import React, { Component } from 'react';
import { connectModal } from 'redux-modal';
import { connect } from 'react-redux';
import { Elements } from 'react-stripe-elements';
import { Field, reduxForm } from 'redux-form';
import Button from 'react-bootstrap-button-loader';
import { Modal } from 'react-bootstrap';
import get from 'lodash/get';
import { toastr } from 'react-redux-toastr';
import { AdvertiserApi } from '../../../api';
import StripeForm from './StripeForm';
import { setLoader, removeLoader } from '../../../actions';

import {
  InputField,
  CheckboxField,
  required
} from '../../form';

class CardsForm extends Component {

  onFormSubmit = (values) => {
    const { dispatch, account, handleHide, card } = this.props;
    const { address_city, address_country, address_line1, address_line2, address_state, address_zip, name, default_source } = values;
    const card_id = card.id;
    const account_id = account.uuid;

    const args = [
      card_id,
      { account_id, address_city, address_country, address_line1, address_line2, address_state, address_zip, name, default_source }
    ];

    dispatch(setLoader('CardForm'));

    dispatch(AdvertiserApi.actions.cardUpdate.patch(...args, (error, success) => {
      dispatch(removeLoader('CardForm'));
      if (success) {
        toastr.success('Card has successfully been updated');
        dispatch(setLoader('getCards'));
        dispatch(AdvertiserApi.actions.cards.get({ account_id: account.uuid }, () => {
          dispatch(removeLoader('getCards'));
        }));
        dispatch(AdvertiserApi.actions.customers());
        handleHide();
      }
    }));
  }

  render() {
    const { show, handleSubmit, handleHide, title, formAction, isLoading, account, card } = this.props;

    return (
      <Modal show={show} onHide={handleHide}>
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        { formAction === 'Add' ?
          (
            <Elements>
              <StripeForm account={account} handleHide={handleHide} handleSubmit={handleSubmit} isLoading={isLoading} />
            </Elements>
          ) :
          (
            <form
              onSubmit={handleSubmit(this.onFormSubmit)}
              className='m-t'
            >
              <Modal.Body>
              <Field
                type='text'
                name='name'
                placeholder='Name of the cardholder'
                label='Name'
                component={InputField}
                validate={[required]}
              />
              <Field
                type='text'
                name='address_line1'
                placeholder='Street Address/PO Box/Company Name'
                label='Address'
                component={InputField}
                validate={[required]}
              />
              <Field
                type='text'
                name='address_line2'
                placeholder='Apartment/Suite/Unit/Building'
                label='Address Line 2'
                component={InputField}
              />
              <div className="row">
                <div className="col-sm-5">
                  <Field
                    type='text'
                    name='address_city'
                    placeholder='City'
                    label='City'
                    component={InputField}
                    validate={[required]}
                  />
                </div>
                <div className="col-sm-3">
                  <Field
                    type='text'
                    name='address_state'
                    placeholder='State'
                    label='State'
                    component={InputField}
                    validate={[required]}
                  />
                </div>
                <div className="col-sm-4">
                  <Field 
                    type='text' 
                    name='address_country'
                    placeholder='Country'
                    label='Country'
                    component={InputField}
                    validate={[required]}
                  />
                </div>
              </div>
              <Field
                name='default_source'
                label='Set as default card'
                type='checkbox'
                singleLine
                component={CheckboxField}
                disabled={card.default_source}
              />
            </Modal.Body>

            <Modal.Footer>
              <Button onClick={handleHide}>Close</Button>
              <Button
                type='submit'
                loading={isLoading}
                bsStyle='primary'
              >
                {formAction || 'Submit'}
              </Button>
            </Modal.Footer>
            </form>
          )
        }
      </Modal>
    );
  }
}

const ResourceForm = reduxForm({
  form: 'CardForm'
});

const ResourceModal = connectModal({
  name: 'CardFormModal'
});

const mapStateToProps = (state) => {
  const { loader, modal: { CardFormModal } } = state;
  const isLoading = loader.includes('CardForm');
  const card = get(CardFormModal, 'props.card', {});

  const initialValues = {
    name: card.name,
    address_line1: card.address_line1,
    address_line2: card.address_line2,
    address_city: card.address_city,
    address_state: card.address_state,
    address_country: card.address_country,
    default_source: card.default_source
  };

  return { isLoading, initialValues };
};

export default connect(mapStateToProps)(ResourceModal(ResourceForm(CardsForm)));
